const subscribeToPlayerInteractions = (
    playerInteractionsInput$,
    playerInteractionsOutput$
) =>
    playerInteractionsInput$
        .subscribe(payload => playerInteractionsOutput$.next(payload));

export default subscribeToPlayerInteractions;
